module.exports = __webpack_public_path__ + "0d74e765913fc6154a3dbe44dc4c5e7c.svg";